import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectSearchComponent } from './modules/project-search/project-search.component';
import { ReviewComponent } from './modules/review/review.component';
import { ReviewsComponent } from './modules/reviews/reviews.component';
import { BidashboardComponent } from './modules/bidashboard/bidashboard.component';
import { MsalGuard } from '@azure/msal-angular';
import { EmbedReviewsComponent } from './modules/reviews/embedreviews.component';
import { AlberIQComponent } from './modules/alberiq/alberiq.component';
import { CanViewPPRListGuard } from './shared/guards/CanViewPPRList.guard';
import { CanViewAlberIQGuard } from './shared/guards/CanViewAlberIQ.guard';
import { CanViewAdminGuard } from './shared/guards/CanViewAdmin.guard';
import { PermissionsComponent } from './modules/permissions/permissions.component';

const routes: Routes = [
  { path: '', component: ProjectSearchComponent, canActivate: [MsalGuard] },
  { path: 'embedreviews/:id', component: EmbedReviewsComponent, canActivate: [MsalGuard, CanViewPPRListGuard] },
  { path: 'embedalberiq', component: AlberIQComponent, canActivate: [MsalGuard, CanViewAlberIQGuard] },
  { path: 'reviews', component: ReviewsComponent, canActivate: [MsalGuard, CanViewPPRListGuard] },
  { path: 'reviews/:id', component: ReviewComponent, canActivate: [MsalGuard, CanViewPPRListGuard] },
  { path: 'dashboards/:id', component: BidashboardComponent, canActivate: [MsalGuard] },
  { path: 'admin/permissions', component: PermissionsComponent, canActivate: [MsalGuard, CanViewAdminGuard] }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
